import React, { useEffect } from 'react'
import Modal from 'react-modal'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { serializeQueryStrings } from '../../utils';
import SortRecordsForm from '../Forms/SortRecordsForm';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '700px',
    },
    overlay: { zIndex: 1000 }
};
export default function SortRecordsModal({ modal, setModal, searchParams, setSearchParams, redirect = '/docket' }) {
    let navigate = useNavigate();

    const handleSubmit = async (values) => {
        const currentParams = Object.fromEntries([...searchParams]);
        
        // Only reset skip if ordering changes, not when changing limit
        const shouldResetSkip = values.ordering !== currentParams.ordering ||
                               values.created_on !== currentParams.created_on ||
                               values.updated_on !== currentParams.updated_on;
        
        const updatedParams = { 
            ...currentParams, 
            ...values, 
            skip: shouldResetSkip ? '0' : currentParams.skip 
        };
        
        setSearchParams(serializeQueryStrings(updatedParams))
        setModal(false)
    }
    const resetFrom = (formik) => {
        formik.resetForm()
        navigate(redirect)
        setModal(false)
    }


    return (
        <Modal
            isOpen={modal}
            style={customStyles}
            contentLabel="Example Modal"
        >
            <div className="container-fluid">

                <div className="d-flex justify-content-between">
                    <h5 className="modal-title mb-3 text-center text-info">Sort Records</h5>
                    <button type="button" className="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close" onClick={() => setModal(false)}></button>
                </div>
                <div className="modal-body" style={{ width: '100%' }}>
                    <SortRecordsForm
                        isLoading={false}
                        handleSubmit={handleSubmit}
                        setModal={setModal}
                        resetFrom={resetFrom}
                        searchParams={searchParams}
                    />
                </div>
            </div>
        </Modal>
    )
}
